import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import {Customer} from '../../../customers/data/customer';
import {CustomersService} from '../../../customers/services/customers.service';
import {AppStateService} from '../../../app-common/services/appState/app-state.service';
import {DomSanitizer} from '@angular/platform-browser';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {LoggerService} from '../../../logging/services/logger.service';
import {AutoComplete} from "primeng/autocomplete";

@Component({
  selector: 'w-customer-field',
  templateUrl: './customer-field.component.html',
  styleUrls: ['./customer-field.component.scss']
})
export class CustomerFieldComponent implements OnInit, OnChanges {

  @Input() customer: Customer;
  @Input() maxLength: number = 45;
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;

  @Output() valueChange: EventEmitter<Customer> = new EventEmitter<Customer>();

  @ViewChild('autoComplete', {static: false}) autoComplete: AutoComplete;

  filteredCustomers: Customer[];
  customerFromQuery: string;

  constructor(public appStateService: AppStateService,
              public sanitizer: DomSanitizer,
              public clientService: CustomersService,
              private loggingService: LoggerService) {
    this.appStateService = appStateService;
    this.sanitizer = sanitizer;
    this.clientService = clientService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customer && changes.customer.currentValue) {
      this.customer[`fullName`] = Customer.getFullName(changes.customer.currentValue);
    }
  }

  ngOnInit() {
    if (this.customer) {
      this.customer[`fullName`] = Customer.getFullName(this.customer);
    }
  }

  async filterUsers(event: any) {
    await this.search(event.query.toLowerCase());
    this.customerFromQuery = event.query.toLowerCase();
  }

  async onSelect(event: Customer) {
    this.valueChange.emit(event);
    setTimeout( () => {
    this.autoComplete.inputEL.nativeElement.blur();
    }, 0);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CustomerFieldComponent, 'Selected customer with id: ' + event.id);
  }

  onClear(): void {
    this.valueChange.emit(undefined);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CustomerFieldComponent, 'Cleared customer field.');
  }

  onUnselect() {
    this.valueChange.emit(undefined);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CustomerFieldComponent, 'Unselected customer.');
  }

  sort(query: string) {
    if (query === undefined || query === '') {
      this.filteredCustomers.sort((a, b) => {
        const textA = a.id;
        const textB = b.id;
        return (textA > textB) ? -1 : 1;
      });
    } else {
      this.filteredCustomers.sort((a, b) => {
        const textA = a.contactName.toUpperCase();
        const textB = b.contactName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
    }
  }


  async search(query: string) {
    const response = await this.clientService.searchCustomer(query, 20, 0, undefined, undefined);
    this.filteredCustomers = [];
    for (const customerDto of response) {
      customerDto.customer[`fullName`] = Customer.getFullName(customerDto.customer);
      this.filteredCustomers.push(customerDto.customer);
    }
    this.sort(query);
  }

  getContactName(customer: Customer) {
    const fullName = customer.contactName;

    if (fullName.length < this.maxLength) {
      return fullName;
    }
    return fullName.substr(0, this.maxLength - 3) + '...';
  }

  getCompanyName(customer: Customer) {
    const companyName = customer.companyName;
    if (companyName.length < this.maxLength) {
      return companyName;
    }
    return companyName.substr(0, this.maxLength - 3) + '...';
  }

  getCustomerName(customer: Customer) {
    if (customer.companyName) {
      if (customer.companyName.toLowerCase().includes(this.customerFromQuery)) {
        return this.getCompanyName(customer) + ' / ' + this.getContactName(customer);
      }
    }
    return this.getContactName(customer);
  }
}
